import React from 'react';
function MoveCenter({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v18M3 17l5-5-5-5M21 17l-5-5 5-5" />
    </svg>
  );
}

export default MoveCenter;
